class Configurator {
  constructor(element, options) {
    this._options = { ...Configurator.options, ...options };
    this._element = element;
    this._initFields = this._initFields.bind(this);
    this._init();
  }

  _init() {
    this._cacheSelectors();
    this._initFields();
  }

  _cacheSelectors() {
    this._fields = [...this._element.querySelectorAll('select')];
    this._selects = [...this._element.querySelectorAll('select')];
  }

  _setSelect = (select) => {
    if (select.selectedIndex) {
      select.setAttribute('data-selected', true);
    } else {
      select.setAttribute('data-selected', false);
    }
  };

  _initFields() {
    this._selects.forEach((select) => {
      this._setSelect(select);
      select.addEventListener(
        'change',
        () => {
          this._setSelect(select);
        },
        true
      );
    });
  }
}

export default Configurator;
